import React from 'react';

const Footer = () => {
    return (
        <footer className='p-5 bg-black mb-0'>
            <small className='text-white'>resource &copy; copyright 2022</small>
           
            
        </footer>
    );
};

export default Footer;

// https://i.ibb.co/yXwFB5B/download.png
// https://i.ibb.co/CmMTN1Z/images-1.png
// https://i.ibb.co/JxhgcTm/unnamed.png